export const textColorOptions = {
  key: 'textColor',
  name: 'Colour',
  editType: 'colour',
  default: 'black',
  options: [
    {
      id: 'black',
      value: '#333333',
      contrast: '#333333',
      border: 'var(--card-border-color)',
      outline: '#333333',
    },

    {
      id: 'white',
      value: '#FFFFFF',
      contrast: '#333333',
      border: 'var(--card-border-color)',
      outline: '#333333',
    },
  ],
};

export const backgroundColorOptions = {
  key: 'backgroundColor',
  name: 'Colour',
  editType: 'colour',
  default: 'white',
  options: [
    {
      id: 'white',
      value: '#FFFFFF',
      contrast: '#333333',
      border: 'var(--card-border-color)',
      outline: '#333333',
      text: '#333333',
    },
    {
      id: 'black',
      value: '#333333',
      contrast: '#FFFFFF',
      outline: '#333333',
      text: '#FFFFFF',
    },
    {
      id: 'yellow',
      value: '#FAEDCB',
      contrast: '#333333',
      outline: '#333333',
      text: '#854D0E',
    },
    {
      id: 'green',
      value: '#C9E4DE',
      contrast: '#333333',
      outline: '#333333',
      text: '#215E29',
    },
    {
      id: 'blue',
      value: '#C6DEF1',
      contrast: '#333333',
      outline: '#333333',
      text: '#204F88',
    },
    {
      id: 'purple',
      value: '#DBCDF0',
      contrast: '#333333',
      outline: '#333333',
      text: '#492970',
    },
    {
      id: 'pink',
      value: '#F2C6DE',
      contrast: '#333333',
      outline: '#333333',
      text: '#7F1D1D',
    },
    {
      id: 'brown',
      value: '#F7D9C4',
      contrast: '#333333',
      outline: '#333333',
      text: '#854D0E',
    },
  ],
};
